/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Handheld Sign', 'sticker name', 'web-stories');

function HandHeldSign({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 36 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.94 38.8113L15.4375 36.7549L2.26593 41.6118L0.050293 50.0343L7.19563 49.1513L18.94 38.8113Z"
        fill="#35A0CD"
      />
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.2486 28.2316C22.553 28.4953 22.6608 28.6815 22.4031 28.96C22.2417 29.1347 21.7371 29.1373 21.3832 29.1149C21.3905 28.467 21.4641 27.96 21.1061 27.6539C21.0839 27.6348 21.0618 27.6179 21.0398 27.6026L21.1214 27.482C21.1214 27.482 21.9444 27.9679 22.2486 28.2316Z"
          fill="#B9242A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6075 31.2198C21.6075 31.2198 22.1251 31.7542 22.2036 32.0622C22.282 32.3699 21.9559 32.6575 21.9559 32.6575C21.9559 32.6575 22.4419 33.0387 22.1687 33.4062C21.9377 33.7173 21.0514 34.0626 20.4033 33.9273C20.4981 33.1091 20.5755 32.2244 20.5593 32.0162C20.5309 31.6525 21.3941 30.0421 21.3835 29.3037C21.3835 29.3037 21.9362 30.1271 22.0333 30.3087C22.1303 30.4904 21.6075 31.2198 21.6075 31.2198Z"
          fill="#B9242A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6784 31.5411C20.7947 31.5588 20.9631 31.5611 21.1184 31.4783C21.3907 31.3328 21.9992 30.55 21.9992 30.55C21.8866 30.8306 21.6076 31.2199 21.6076 31.2199L21.1163 31.6322C20.9682 31.7566 20.7168 31.8397 20.5744 31.8795C20.5938 31.7891 20.6307 31.6737 20.6784 31.5411Z"
          fill="#852124"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.3834 29.2948L22.8599 19.7075L21.2541 19.525C20.8048 22.648 20.457 25.796 19.7653 28.876C19.7653 28.876 19.8734 28.7575 20.098 28.1676C20.3227 27.5778 20.7141 27.3184 21.1062 27.6538C21.4969 27.9875 21.3737 28.5605 21.3834 29.2948ZM20.5614 32.1053C20.672 32.1129 20.7829 32.1176 20.8938 32.1196L21.2747 29.9212C21.0459 30.713 20.5373 31.7353 20.5593 32.0159C20.5612 32.0382 20.5619 32.0684 20.5614 32.1053Z"
          fill="#452A49"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5388 36.8033C19.5388 36.8033 20.0569 35.8703 20.1934 35.3404C20.33 34.8104 20.5877 32.3797 20.5593 32.0159C20.531 31.6522 21.3942 30.0419 21.3836 29.3034C21.373 28.565 21.4986 27.9889 21.1065 27.6537C20.7144 27.3183 20.323 27.5777 20.0983 28.1675C19.8735 28.7574 19.7656 28.8759 19.7656 28.8759L19.8344 27.5725C19.8344 27.5725 19.1287 27.6387 18.9078 27.7548C18.6869 27.8709 18.1012 28.8884 17.5612 29.3831C17.0212 29.8778 16.852 30.0058 16.7507 30.5615C16.6495 31.1172 16.6294 34.7051 16.5334 35.2837C16.4377 35.8623 15.9612 37.0096 15.9612 37.0096L19.1185 37.7373L19.5388 36.8033Z"
          fill="#B9242A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.1521 32.401C22.0751 32.5522 21.9559 32.6575 21.9559 32.6575C21.9559 32.6575 20.8407 33.2335 20.6088 33.3035C20.5559 33.3193 20.5088 33.3314 20.4673 33.3403C20.4732 33.2834 20.4787 33.2273 20.484 33.1718C20.7844 33.0596 21.3525 32.8437 21.5185 32.7547C21.6532 32.6822 21.9396 32.5211 22.1521 32.401Z"
          fill="#852124"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0648 27.5366L19.7655 28.8761C19.7655 28.8761 19.1958 30.1846 18.8933 30.6322C18.5907 31.0799 18.1899 31.3609 18.1899 31.3609C18.1899 31.3609 18.6441 30.8136 18.6409 30.6778C18.6378 30.5451 18.2941 30.2747 18.2788 30.2626C18.2943 30.2747 18.6482 30.5477 18.8123 30.437C18.9802 30.3238 19.1798 29.9349 19.1783 29.8669C19.1767 29.799 18.9311 29.4239 18.9311 29.4239C18.9311 29.4239 19.2351 29.3903 19.3755 29.1618C19.5159 28.9332 19.6052 28.0831 19.5926 27.9692C19.585 27.9012 19.2284 27.8052 18.9421 27.739C19.1939 27.6327 20.0648 27.5366 20.0648 27.5366Z"
          fill="#852124"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5612 32.0578L20.8149 32.1006L20.7562 32.3226C20.7375 32.3941 20.6574 32.4467 20.5438 32.4741C20.5566 32.2899 20.5631 32.144 20.5612 32.0578Z"
          fill="#B9242A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.014 35.3574L19.8342 37.3664L19.1812 39.4337L14.055 37.0215L15.014 35.3574Z"
          fill="#23799F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9989 37.1349C15.118 37.1753 15.2215 37.239 15.3109 37.3267C15.3375 37.3527 15.3724 37.3071 15.3462 37.2814C15.253 37.19 15.1447 37.1238 15.021 37.0819C14.9861 37.07 14.964 37.123 14.9989 37.1349Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8598 36.2126C14.9593 36.2663 15.0587 36.32 15.1582 36.3737C15.1908 36.3913 15.2129 36.3382 15.1803 36.3207C15.0808 36.267 14.9814 36.2133 14.8819 36.1596C14.8494 36.142 14.8278 36.1953 14.8598 36.2126Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2196 36.2038C16.329 36.2591 16.4304 36.3264 16.524 36.4054C16.5527 36.4294 16.5875 36.3839 16.5593 36.3601C16.4618 36.2778 16.356 36.2085 16.2417 36.1508C16.2088 36.1342 16.1867 36.1872 16.2196 36.2038Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6828 36.6754C14.7771 36.7148 14.872 36.7543 14.9663 36.7936C15.0008 36.808 15.0229 36.7549 14.9884 36.7406C14.8941 36.7013 14.7992 36.6617 14.7049 36.6224C14.671 36.6083 14.6489 36.6613 14.6828 36.6754Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.388 35.9312C15.4765 35.9409 15.5553 35.9782 15.6167 36.0431C15.6419 36.0697 15.6879 36.0352 15.6627 36.0085C15.5903 35.9322 15.5001 35.8858 15.3953 35.8742C15.3584 35.8701 15.351 35.9271 15.388 35.9312Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7971 36.8163C15.8976 36.8435 15.982 36.8969 16.0476 36.9784C16.0708 37.0073 16.1163 36.9725 16.0932 36.9437C16.0223 36.8551 15.9292 36.7931 15.8192 36.7633C15.7839 36.7538 15.7612 36.8067 15.7971 36.8163Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0217 37.5562C16.1242 37.6154 16.2335 37.6525 16.3509 37.6688C16.3875 37.6739 16.3948 37.6169 16.3582 37.6118C16.2458 37.5962 16.142 37.5599 16.0438 37.5032C16.0122 37.4848 15.9901 37.5379 16.0217 37.5562Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6132 37.2545C16.7081 37.2941 16.8024 37.3334 16.8972 37.3729C16.9312 37.387 16.9533 37.334 16.9193 37.3199C16.8245 37.2804 16.7302 37.2411 16.6353 37.2015C16.6014 37.1874 16.5793 37.2404 16.6132 37.2545Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7972 36.8749C16.9149 36.9467 17.0432 36.9792 17.181 36.9705C17.2177 36.9681 17.2103 36.9113 17.1736 36.9136C17.0521 36.9211 16.9362 36.8928 16.8325 36.8296C16.8012 36.8106 16.7654 36.8556 16.7972 36.8749Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0105 37.6815C17.0985 37.7024 17.177 37.7418 17.2477 37.7984C17.2767 37.8216 17.312 37.7763 17.283 37.7531C17.2044 37.69 17.116 37.6479 17.0174 37.6244C16.9817 37.6159 16.9748 37.6731 17.0105 37.6815Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2139 38.2508C17.3462 38.3059 17.4785 38.361 17.6108 38.4162C17.6452 38.4305 17.6673 38.3775 17.6329 38.3632C17.5006 38.308 17.3683 38.2529 17.236 38.1978C17.2016 38.1834 17.1795 38.2364 17.2139 38.2508Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3983 37.5107C17.4689 37.5536 17.5395 37.5965 17.6101 37.6394C17.6409 37.6582 17.6767 37.6131 17.6454 37.5941C17.5748 37.5511 17.5042 37.5082 17.4336 37.4653C17.4023 37.4463 17.367 37.4916 17.3983 37.5107Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8648 36.8895C17.9497 36.9248 18.035 36.9604 18.1199 36.9958C18.1543 37.0101 18.1764 36.9571 18.142 36.9428C18.0571 36.9074 17.9718 36.8718 17.8869 36.8364C17.8525 36.8221 17.8304 36.8751 17.8648 36.8895Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1924 37.6213C18.2884 37.6551 18.3723 37.7096 18.4401 37.7859C18.4649 37.8135 18.511 37.779 18.4862 37.7513C18.411 37.6673 18.3202 37.6055 18.2144 37.5683C18.1797 37.5561 18.1571 37.6089 18.1924 37.6213Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9558 37.9498C18.0747 37.9838 18.1904 38.0238 18.3045 38.0705C18.3386 38.0843 18.3607 38.0313 18.3266 38.0174C18.2125 37.9708 18.0968 37.9308 17.978 37.8967C17.9429 37.8867 17.9203 37.9396 17.9558 37.9498Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1024 38.3965C18.2016 38.424 18.2926 38.4658 18.3773 38.5241C18.4078 38.5452 18.443 38.4999 18.4126 38.4788C18.3238 38.4176 18.2285 38.3723 18.1245 38.3435C18.0893 38.3338 18.0667 38.3866 18.1024 38.3965Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.927 38.3277C18.9781 38.3374 19.0291 38.347 19.0806 38.357C19.117 38.3639 19.1238 38.3067 19.088 38.3C19.0365 38.2901 18.9854 38.2804 18.9339 38.2705C18.898 38.2638 18.8907 38.3207 18.927 38.3277Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.1928 37.5273C19.2298 37.5116 19.2776 37.5249 19.2975 37.5614C19.3152 37.5934 19.3687 37.572 19.3511 37.5397C19.3156 37.4758 19.2393 37.4454 19.1705 37.474C19.1364 37.4884 19.1582 37.5415 19.1928 37.5273Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5575 38.8421C18.5993 38.8486 18.6406 38.855 18.6824 38.8616C18.7187 38.8671 18.7261 38.8102 18.6897 38.8046C18.6479 38.798 18.6062 38.7915 18.5649 38.7851C18.5281 38.7792 18.5207 38.8362 18.5575 38.8421Z"
          fill="#FFFFFE"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.69629 23.1002L35.6194 23.1002L35.6194 3.32518e-07L8.69629 0L8.69629 23.1002Z"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.6194 23.1002L8.69629 23.1002L8.69629 0L35.6194 3.32518e-07L35.6194 23.1002ZM34.8501 0.769231L9.46552 0.769231L9.46552 22.3309L34.8501 22.331L34.8501 0.769231Z"
        fill="#C4C3DC"
      />
      <defs>
        <clipPath id="clip0">
          <rect
            width="6.32377"
            height="20.4792"
            fill="white"
            transform="translate(18.321 19.0107) rotate(9.95116)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

HandHeldSign.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 36 / 51,
  svg: HandHeldSign,
  title,
};
